<template>
  <div>
    <div class="glide">
      <div class="glide__track flex flex-col" data-glide-el="track">
        <ul class="glide__slides flex-1">
          <li
            v-for="c in courses"
            v-bind:key="c.id"
            class="glide__slide pb-4 grid"
          >
            <div class="flex flex-col rounded-lg shadow-lg overflow-hidden" style="height: 430px;">
              <div class="flex-shrink-0">
                <img
                  v-if="c.image"
                  :src="c.image"
                  class="h-48 w-full object-cover"
                  alt=""
                />
                <img
                  v-else
                  src="/images/COURSE_DEFAULT.jpg"
                  class="h-48 w-full object-cover"
                  alt=""
                />
              </div>
              <div class="flex-1 bg-white p-6 flex flex-col justify-between">
                <div class="flex-1">
                  <p class="text-sm font-medium text-indigo-600">
                    {{ c.department.name }}
                    <!-- <a href="#" class="hover:underline"></a> -->
                  </p>
                  <router-link
                    :to="{ name: 'course_show', params: { id: c.id } }"
                    class="block mt-2"
                  >
                    <p class="text-xl font-semibold text-gray-900">
                      {{ c.name }}
                    </p>
                    <!-- <p class="mt-3 text-base text-gray-500"></p> -->
                  </router-link>
                </div>
                <div class="mt-6 flex items-center">
                  <div class="flex-shrink-0">
                    <!--
                    <img
                      class="h-10 w-10 rounded-full"
                      src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixqx=xc9myIFc3S&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                      alt=""
                    />
                    -->
                    <img
                      class="h-10 w-10 rounded-full"
                      :src="c.user.userphoto"
                      alt=""
                    />

                  </div>
                  <div class="ml-3">
                    <p class="text-sm font-medium text-gray-900">
                      <router-link
                        :to="{ name: 'user_show', params: { id: c.user_id } }"
                        class="hover:underline"
                      >
                        {{ c.user.name }}
                      </router-link>
                    </p>
                    <!-- <div class="flex space-x-1 text-sm text-gray-500">
                      <time datetime="2020-03-16"> Mar 16, 2020 </time>
                      <span aria-hidden="true"> &middot; </span>
                      <span> 6 min read </span>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- <div class="" id="card-slider1">
      <div
        v-for="c in courses"
        v-bind:key="c.id"
        class="flex flex-col rounded-lg shadow-lg overflow-hidden"
      >
        <div class="flex-shrink-0">
          <img
            v-if="c.image"
            :src="c.image"
            class="h-48 w-full object-cover"
            alt=""
          />
          <img
            v-else
            src="/images/COURSE_DEFAULT.jpg"
            class="h-48 w-full object-cover"
            alt=""
          />
        </div>
        <div class="flex-1 bg-white p-6 flex flex-col justify-between">
          <div class="flex-1">
            <p class="text-sm font-medium text-indigo-600">
              <a href="#" class="hover:underline"> Article </a>
            </p>
            <router-link
              :to="{ name: 'course_show', params: { id: c.id } }"
              class="block mt-2"
            >
              <p class="text-xl font-semibold text-gray-900">
                {{ c.name }}
              </p>
              <p class="mt-3 text-base text-gray-500">
                {{ c.department.name }}
              </p>
            </router-link>
          </div>
          <div class="mt-6 flex items-center">
            <div class="flex-shrink-0">
              <router-link
                :to="{ name: 'user_show', params: { id: c.user_id } }"
              >
                <span class="sr-only">{{ c.user.name }}</span>
                <img
                  class="h-10 w-10 rounded-full"
                  src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixqx=xc9myIFc3S&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                  alt=""
              /></router-link>
            </div>
            <div class="ml-3">
              <p class="text-sm font-medium text-gray-900">
                <a href="#" class="hover:underline"> Roel Aufderehar </a>
              </p>
              <div class="flex space-x-1 text-sm text-gray-500">
                <time datetime="2020-03-16"> Mar 16, 2020 </time>
                <span aria-hidden="true"> &middot; </span>
                <span> 6 min read </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

  <!-- <div id="root" class="container">
      <div class="section card-slider1" id="card-slider1">
        <div
          v-for="c in courses"
          v-bind:key="c.id"
          class="card"
          style="width: 18rem"
        >
          <div class="card-img-top" style="height: 150px; overflow: hidden">
            <img
              style="height: 150px"
              v-if="c.image"
              :src="c.image"
              alt="..."
            />
            <img
              style="height: 150px"
              v-else
              src="/images/COURSE_DEFAULT.jpg"
              alt="..."
            />
          </div>
          <div class="card-body" style="height: 230px">

            <h5>
              <router-link
                :to="{ name: 'course_show', params: { id: c.id } }"
                >{{ c.name }}</router-link
              >
            </h5>

            <p class="card-text" style="font-weight: bold">
              {{ c.department.name }}
            </p>
            <p class="text-muted">
              <span class="text-uppercase small font-weight-bold">
                Автор:
              </span>
              <router-link
                :to="{ name: 'user_show', params: { id: c.user_id } }"
                >{{ c.user.name }}</router-link
              >
            </p>
          </div>
        </div>
      </div>
    </div>  -->
</template>

<script>
// import jQuery from "jquery";
// import "lightslider";
import Glide from "@glidejs/glide";

export default {
  props: {
    courses: Array,
  },
  mounted() {
    new Glide(".glide", {
      type: "carousel",
      startAt: 0,
      perView: 3,
      gap: 30,
      autoplay: 3000,
      animationDuration: 800,
      breakpoints: {
        1024: {
          perView: 2,
        },
        768: {
          perView: 1,
        },
      },
    }).mount();

    // jQuery("#card-slider1").lightSlider({
    //   onSliderLoad: function (el) {

    //     var container = jQuery(el),
    //       children = container.children();

    //     children.each(function () {
    //       jQuery(this).addClass("mb-6");
    //     });
    //   },
    //   item: 3,
    //   autoWidth: false,
    //   galleryMargin: 50,
    //   slideMove: 1,
    //   slideMargin: 50,
    //   loop: true,
    //   adaptiveHeight: true,
    //   responsive: [
    //     {
    //       breakpoint: 992,
    //       settings: {
    //         item: 3,
    //         slideMargin: 20,
    //       },
    //     },
    //     {
    //       breakpoint: 1024,
    //       settings: {
    //         item: 2,
    //         slideMargin: 30,
    //       },
    //     },
    //     {
    //       breakpoint: 576,
    //       settings: {
    //         item: 1,
    //       },
    //     },
    //   ],
    // });
  },
};
</script>



